import { render, staticRenderFns } from "./Checkbox.ts.vue?vue&type=template&id=1f6553b5"
import script from "./Checkbox.ts.vue?vue&type=script&lang=ts"
export * from "./Checkbox.ts.vue?vue&type=script&lang=ts"
import style0 from "./Checkbox.ts.vue?vue&type=style&index=0&id=1f6553b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports